<template>
    <div>课程列表</div>
</template>

<script>
export default {

}
</script>

<style>

</style>